export const name = 'download';

export const DEFAULT_TITLE = 'Generando el archivo';
export const DEFAULT_MESSAGE = 'Estamos preparando la descarga…';
export const DEFAULT_HINT =
  'Puede demorar según el rango de fechas y los filtros seleccionados.';

export const TIMEOUT_MESSAGE =
  'La descarga superó los 5 minutos y se canceló. Probá acotar el rango de fechas.';
export const FAILURE_MESSAGE = 'No se pudo generar el archivo.';
